import { Heading, Icon, Radio } from "@trueskin-web/components"
import { checkCircleFilledIcon } from "@trueskin-web/theme/icons/checkCircleFilledIcon"

const PlanHeader = ({
  isSelected,
  title,
  priceTitle,
  priceWithoutDiscounts,
  isSubscription,
  version,
}) => (
  <div
    sx={{
      display: "flex",
      alignItems: "center",
      lineHeight: "body",
      width: "100%",
      minWidth: 0,
    }}
  >
    {isSelected ? (
      <Icon
        icon={checkCircleFilledIcon}
        color={version === "v2" ? "primary" : "#1A1C2B"}
        size="sm"
        sx={{
          mr: 4,
          transform: "scale(1.6) translateX(1px)",
        }}
      />
    ) : (
      <Radio
        data-testid="web-portal-plan-selection-radio-btn"
        readOnly
        size="sm"
        sx={{
          mr: 3,
          "& > div": {
            borderColor: "disabled",
            width: "20px",
            height: "20px",
          },
          "& input:hover + div": {
            boxShadow: "none",
          },
        }}
      />
    )}

    <Heading
      as="h3"
      size="xsm"
      sx={{
        mr: 3,
        fontFamily: "display",
        lineHeight: "inherit",
      }}
    >
      {title}
    </Heading>

    <div sx={{ ml: "auto", whiteSpace: "nowrap" }}>
      {isSubscription && priceWithoutDiscounts ? (
        <span
          sx={{
            fontSize: 3,
            color: "disabled",
            textDecoration: "line-through",
          }}
        >
          {priceWithoutDiscounts}
        </span>
      ) : null}{" "}
      <span
        sx={{
          fontFamily: "display",
          fontSize: 3,
        }}
      >
        {priceTitle}
      </span>
      {isSubscription ? (
        <span sx={{ fontSize: 1, fontWeight: "normal" }}>/Monat</span>
      ) : null}
    </div>
  </div>
)

export default PlanHeader
